import Bs4MainDispatch from './Bs4MainDispatch';
import {loadExternalScript} from './Bs4Components/Bs4Utils'
import { initializeApp } from "https://www.gstatic.com/firebasejs/10.12.5/firebase-app.js";
import { getMessaging, getToken, onMessage, useServiceWorker, onTokenRefresh } from "https://www.gstatic.com/firebasejs/10.12.5/firebase-messaging.js";

// const config = {
// 	apiKey: "AIzaSyDoZ8NIUGOI4KAt--T-BWCZVvLOjN5n44M",
// 	authDomain: "notificationsbs4.firebaseapp.com",
// 	databaseURL: "https://notificationsbs4.firebaseio.com",
// 	projectId: "notificationsbs4",
// 	storageBucket: "notificationsbs4.appspot.com",
// 	messagingSenderId: "1019080428420"
// };
const config = {
    apiKey: "AIzaSyDoZ8NIUGOI4KAt--T-BWCZVvLOjN5n44M",
    authDomain: "notificationsbs4.firebaseapp.com",
    databaseURL: "https://notificationsbs4.firebaseio.com",
    projectId: "notificationsbs4",
    storageBucket: "notificationsbs4.appspot.com",
    messagingSenderId: "1019080428420",
    appId: "1:1019080428420:web:8326c14ae801866add6bd1",
    measurementId: "G-T16KZDQSJP"
  };

export default function bs4NotificationsFCM() {
  if (window.doneBs4NotificationsFCM) {
    console.log('=FCM= loadExternalScript ... exist', window);
    return;
  }
  
  window.doneBs4NotificationsFCM = true;
  notificationsFCM();
}

function notificationsFCM() {
  const app = initializeApp(config);
  const messaging = getMessaging(app);
  
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('firebase-messaging-sw.js')
        .then((registration) => {
        
        console.log('Service Worker registered with scope:', registration.scope);

        Notification.requestPermission().then(permission =>{
            if (permission === 'granted') {
                getToken(messaging, { 
                    vapidKey: 'BC1QRMRF7tc7qG6zDLzo1AFi17ndBR83D_Y_tLgFplvjkZnVOOLBFDMUyU7dwdnBAZhFH3uBbeVt7eBlsfSFBYU',
                    serviceWorkerRegistration: registration
                }).then((currentToken) => {
                    if (currentToken) {
                        sendTokenToServer(currentToken);
                    } else {
                        console.log('No registration token available. Request permission to generate one.');
                    }
                });
            } else {
                console.log('Unable to get permission to notify.');
            }
        });

        }).catch((err) => {
        console.log('Service Worker registration failed:', err);
        });
    }

        onMessage(messaging, (payload) => {
            var notificationTitle = payload.notification.title;
            var notificationOptions = {
                body: payload.notification.body,
                icon: payload.notification.icon,
            };
            
            if (typeof payload.data !== 'undefined' && typeof payload.data.id !== 'undefined' && payload.data.id != '') {
                notificationOptions.tag = payload.data.id;
            }
            
            if (!("Notification" in window)) {
                console.log("=FCM= This browser does not support system notifications");
            }
            else if (Notification.permission === "granted") {
                setTimeout(function() {
                    var notificationFCM = new Notification(notificationTitle, notificationOptions);
                    notificationFCM.onclick = function(event) {
                        event.preventDefault(); 
                        tryOpenMsg(payload)      
                        this.close();
                    }
                }, 1);
            }
        });

      function tryOpenMsg(payload) {
        if (window.Bs4ExtJs) {
          return window.Bs4ExtJs.getApplication().notificationNow(payload)
        }
        const url = payload.notification.click_action;
        const appleBs4 = Bs4MainDispatch.getAppleBs4();
        if (appleBs4) window.open(url, '_self');
        else window.open(url, '_blank'); 
      }

      function sendTokenToServer(token) {
        console.log('=FCM= send token')
        console.log(token)
        if (token) {
          const param = "token="+token;
          const http = new XMLHttpRequest();
          //let url = "web.php?com=Bs4TokenFcm";
          const url = Bs4MainDispatch.getUrlPath("web.php?com=Bs4TokenFcm")
          http.open("POST", url, true);
          http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
          http.send(param);
        }
      }
}
  